import React from 'react';
import { ArrowRight, ShieldCheck, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="pt-28 pb-16 md:pb-24 bg-white px-5 relative overflow-hidden" data-id="element-94">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-95">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] bg-emerald-100 rounded-full blur-[100px] mix-blend-multiply" data-id="element-96"></div>
        <div className="absolute top-40 -left-20 w-[400px] h-[400px] bg-amber-50 rounded-full blur-[80px] mix-blend-multiply" data-id="element-97"></div>
        <div className="absolute bottom-0 right-1/3 w-[450px] h-[450px] bg-rose-50 rounded-full blur-[90px] mix-blend-multiply" data-id="element-98"></div>
      </div>

      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-emerald-100 shadow-sm mb-6" data-id="element-100">
          <Sparkles className="w-4 h-4 text-emerald-600" data-id="element-101" />
          <span className="text-xs md:text-sm font-bold text-emerald-900 uppercase tracking-wide" data-id="element-102">
            Para mujeres en la Pre y Postmenopausia
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-7xl lg:text-8xl font-black text-gray-900 mb-4 leading-[1.1] tracking-tight" data-id="element-103">
          Manual de Biohacking <br data-id="element-104" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-emerald-500" data-id="element-105">
            + 800 Recetas
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-3xl font-serif italic text-gray-600 mb-6" data-id="element-106">
          para la Pre y Postmenopausia
        </motion.p>

        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-2xl font-medium text-gray-800 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-107">
          Tu guía integral para recuperar energía, equilibrar hormonas y
          sentirte vital en esta nueva etapa
        </motion.h3>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-base md:text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-108">
          Más de 800 recetas antiinflamatorias y protocolos de biohacking
          diseñados específicamente para estabilizar tu energía y mejorar tu
          metabolismo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-109">
          {['Equilibrio hormonal', 'Más energía', 'Menos inflamación', 'Mejor descanso'].map((benefit, i) => <span key={i} className="px-4 py-2 bg-white rounded-full shadow-sm border border-gray-200 text-gray-800 font-semibold text-sm flex items-center gap-2" data-id="element-110">
              <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-111"></span>
              {benefit}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mb-10 flex justify-center" data-id="element-112">
          <a href="#compra" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/7iLcYpcrQnxSra9yNcCtgw/mocap_alimentacion.png" alt="Manual de Biohacking + 800 Recetas para la Menopausia" className="max-w-full h-auto md:max-w-4xl mx-auto drop-shadow-2xl rounded-2xl" data-id="element-114" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} className="flex flex-col items-center gap-4" data-id="element-115">
          <a href="#compra" className="bg-emerald-600 hover:bg-emerald-700 text-white text-lg md:text-2xl font-bold py-4 px-8 md:py-5 md:px-12 rounded-full shadow-lg hover:shadow-emerald-500/30 transition-all transform hover:-translate-y-1 flex items-center gap-3 w-full md:w-auto justify-center group relative overflow-hidden" data-id="element-116">
            <span className="relative z-10 flex items-center gap-2" data-id="element-117">
              SÍ, QUIERO MI ACCESO AHORA
              <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-118" />
            </span>
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1s_infinite]" data-id="element-119"></div>
          </a>

          <div className="flex items-center gap-2 text-gray-500 text-sm font-medium" data-id="element-120">
            <ShieldCheck className="w-4 h-4 text-emerald-600" data-id="element-121" />
            <span data-id="element-122">Garantía de satisfacción de 7 días</span>
          </div>
        </motion.div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gray-200" data-id="element-123"></div>
    </section>;
}